import React, { useState } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Message, Row, Col } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ManageProjectStatusForm from './ManageProjectCoordinatorForm'
import ManageProjectStatusTable from './ManageProjectCoordinatorTable'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ManageProjectCoordinatorForm from './ManageProjectCoordinatorForm'
import ProjectInfoView from '../projectBasicInfo/ProjectInfoView'
import {
  getManagementProjectCoordinator,
  getManagementProjectCoordinatorPage,
  updateManagementProjectCoordinator,
} from '../../redux/actions/adminProjectManagemant'
import PopupModal from '../../components/modal/PopupModal'

export default function ManageProjectCoordinatorWidget(props) {
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props?.schema)
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isSelectError, setIsSeletError] = useState(false)
  const [isChangeSuccess, setIsChangeSuccess] = useState(false)
  const [expandedSearch, setExpandedSearch] = useState(true)
  const [isSubmit, setIsSubmit] = useState(false)
  const [projectInfo, setProjectInfo] = useState()
  const [request, setRequest] = useState()

  const onSelect = async (data) => {
    console.log('data=', data)
    startLoading()
    setIsSeletError('')
    try {
      const _schema = await getManagementProjectCoordinator(data.id)

      setExpandedSearch(false)
      setProjectInfo(_schema)
    } catch (e) {
      console.log('error', e)
      setIsSeletError(
        e?.response?.data?.errors?.message ||
          'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
      )
    }
    doneLoading()
  }

  const handleSave = async (request) => {
    startLoading()
    setIsError('')
    setIsChangeSuccess(false)
    try {
      const response = await updateManagementProjectCoordinator(
        projectInfo.projectInfo.projectId,
        request
      )

      setIsChangeSuccess(true)
      setProjectInfo()
      setRequest()
      setExpandedSearch(true)
    } catch (e) {
      console.log('error', e)
      setIsError(
        e?.response?.data?.errors?.message ||
          'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
      )
    }
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('data => ', data)
    setRequest({
      note: data.note,
      employeeCode: data.projectCoordinator,
    })
    setIsSubmit(true)
  }

  const onConfirm = () => {
    setIsSubmit(false)
    handleSave(request)
  }
  const onNotConfirm = () => {
    setIsSubmit(false)
    setRequest()
  }

  return (
    <>
      {/* <Panel shaded header={formSchema.header} collapsible defaultExpanded> */}
      <ManageProjectStatusTable
        schema={formSchema.searchForm}
        onSelect={onSelect}
        expanded={expandedSearch}
        isReload={isChangeSuccess}
      />
      {isSelectError && (
        <Message
          showIcon
          type="error"
          description={isSelectError}
          closable
          onClose={() => {
            setIsError('')
          }}
        />
      )}
      {/* </Panel> */}

      {projectInfo && (
        <>
          {/* <hr /> */}
          <Panel
            header={projectInfo.header}
            shaded
            bordered
            collapsible
            defaultExpanded
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            {projectInfo.projectInfo && <ProjectInfoView schema={projectInfo.projectInfo} />}

            <ManageProjectCoordinatorForm
              schema={projectInfo}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
            {isError && (
              <Message
                showIcon
                type="error"
                description={isError}
                closable
                onClose={() => {
                  setIsError('')
                }}
              />
            )}

            <Row style={{ marginTop: 20 }}>
              <Col xs={24} sm={24} md={6} lg={3}>
                <SaveButton block onClick={handleSubmit(onSubmit)}>
                  {`บันทึก`}
                </SaveButton>
              </Col>
              <Col xs={24} sm={24} md={6} lg={3}>
                <CancelButton
                  block
                  onClick={() => {
                    setProjectInfo()
                    setExpandedSearch(true)
                  }}
                >
                  {'ยกเลิก'}
                </CancelButton>
              </Col>
            </Row>
          </Panel>

          <PopupModal
            title={'ยืนยันการบันทึก'}
            isShow={isSubmit}
            body={isSubmit && `ยืนยันการเปลี่ยนผู้ประสานงานโครงการ`}
            onClickSubmit={onConfirm}
            onClickCancel={onNotConfirm}
            submitText="ยืนยัน"
            cancelText="ยกเลิก"
          />
        </>
      )}
    </>
  )
}
